<section class="hero" [ngStyle]="data.image && { 'background-image': 'url(' + data.image + ')' }">
  <div class="wrapper">
    <div class="color-overlay" [style.background-color]="data.color"></div>

    <div class="hero-content-container">
      <div class="hero-content-background"></div>
      <div class="hero-content">
        <div class="hero-title" [ngStyle]="data.title && { 'background-image': 'url(' + data.title + ')' }"></div>
        <div class="hero-text">{{ data.body }}</div>
      </div>
    </div>
  </div>
</section>